import {
  Component, InjectReactive, Vue, Watch,
} from 'vue-property-decorator';
import styles from './breadcrumb.module.scss';
import WithRender from './breadcrumb.html';
// models
import { BreadCrumbModel } from '@/models/breadcrumb';
import { BreadcrumbId } from '@/services/staticLookups';
import UserModel from '@/models/user';
import { RouteMeta } from 'vue-router';
import { isEmptyObject } from '@/utils/global';

@WithRender
@Component
export default class BreadCrumb extends Vue {
  @InjectReactive()
  public userInfo!: UserModel;

  @InjectReactive()
  private isUserInfoLoading!: boolean;

  public styles = styles;
  public showBreadCrumb = false;
  public breadcrumbId = BreadcrumbId;

  public baseBreadcrumb: BreadCrumbModel[] = [];

  public breadcrumbs: BreadCrumbModel[] = [];

  public get isHighlighted() {
    const { path } = this.$route;
    const dynamicallyHighlightedFromRouter = this.getRouteMeta()?.highlighted || false;
    const highlightedRoutes: string[] = [];

    return highlightedRoutes.includes(path.toLocaleLowerCase()) || dynamicallyHighlightedFromRouter;
  }

  get isLoggedInUser(): boolean {
    return !isEmptyObject(this.userInfo);
  }

  @Watch('isLoggedInUser', { immediate: true })
  public appendDynamicBreadcrumbs() {
    const requiredText = this.isLoggedInUser ? 'dashboard' : 'home';
    const requiredApp = this.isLoggedInUser ? 'dashboard' : 'Landing';

    const initialBreadCrumbs = [
      {
        external: true,
        text: this.$t(requiredText) as string,
        href: `/applications/${requiredApp}`,
      },
    ];

    this.breadcrumbs = [...initialBreadCrumbs];
    this.baseBreadcrumb = [...initialBreadCrumbs];

    this.updateBreadCrumbs();
  }

  get isVisibleBreadCrumb(): boolean {
    const enhancedMeta = this.getRouteMeta(this.$route);
    const isShowPropAvailable = 'showBreadcrumb' in enhancedMeta;
    const showBreadCrumb = isShowPropAvailable ? enhancedMeta.showBreadCrumb : true;

    return showBreadCrumb && this.$route.fullPath !== '/';
  }

  @Watch('$route')
  public updateBreadCrumbs() {
    this.showBreadCrumb = this.isVisibleBreadCrumb;

    let enhancedBreadcrumbs: BreadCrumbModel[] = [...this.baseBreadcrumb];

    this.$route.matched.forEach((route) => {
      const enhancedMeta = this.getRouteMeta(route);

      const hasBreadcrumb = 'breadcrumb' in enhancedMeta;

      if (hasBreadcrumb) {
        enhancedBreadcrumbs = enhancedBreadcrumbs.concat(enhancedMeta.breadcrumb);
      } else {
        enhancedBreadcrumbs = [...this.baseBreadcrumb];
      }
    });

    // ? update [disabled/external] prop
    this.breadcrumbs = enhancedBreadcrumbs.map((route, index) => ({
      ...route,
      external: route.external || false,
      disabled: index === (enhancedBreadcrumbs.length - 1),
    }));
  }

  public getRouteMeta(route: RouteMeta = this.$route): RouteMeta {
    const { meta } = route;

    return typeof meta === 'function' ? meta(this.$route) : meta;
  }

  public onClickBreadcrumb(route: BreadCrumbModel) {
    this.$router.push(route.href || '');
  }
}
